var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftChevron16 = function SvgLeftChevron16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79 4.195a.636.636 0 0 1 0 .943L3.725 8l3.067 2.862a.636.636 0 0 1 0 .943.75.75 0 0 1-1.01 0L2.209 8.47a.636.636 0 0 1 0-.942l3.572-3.334a.75.75 0 0 1 1.01 0Z",
    fill: "currentColor",
    fillOpacity: 0.64
  })));
};
export default SvgLeftChevron16;